import { CalculatePricePromotion } from '@teko/cart/v2';
import { Body, Image, Shape, styled } from '@teko/ds-mobile';
import defaultPromotion from 'assets/default-promotion.svg';
import DOMPurify from 'dompurify';

interface DefaultPromotionsProps {
  promotions: CalculatePricePromotion['promotions'];
}

export const DefaultPromotions: React.FC<DefaultPromotionsProps> = (props) => {
  const { promotions } = props;

  return (
    <Shape padding={['s8', 's0']} backgroundColor="white">
      <Shape paddingLeft="s8">
        <Image src={defaultPromotion} width="140px" height="24px" />
      </Shape>
      <PromotionsWrapper>
        <StyledUl>
          {promotions.map((promotion, index) => {
            // tier promotions will have no title
            return !!promotion.title ? (
              <li key={`${index}${promotion.promotionId}`}>
                <Body weight="regular">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify?.sanitize?.(promotion.title),
                    }}
                    style={{ whiteSpace: 'pre-line' }}
                  />
                  <Body weight="regular" color="#F89E33">
                    {promotion.highlightedDescriptions?.[0]}
                  </Body>
                </Body>
              </li>
            ) : null;
          })}
        </StyledUl>
      </PromotionsWrapper>
    </Shape>
  );
};

const PromotionsWrapper = styled(Shape)`
  padding: 16px 8px;
  background: linear-gradient(
    180deg,
    rgba(250, 225, 76, 0.1) 4.81%,
    rgba(250, 225, 76, 0) 100%
  );
  border: 1px solid #ffd591;
  border-radius: 8px;
  margin-top: -15px;
`;

const StyledUl = styled.ul`
  padding-left: 0; // remove default padding of ul
  margin: 0;
  margin-left: 2rem;
  img {
    height: 20px;
    width: 20px;
    border-radius: 4px;
    border: 1px solid #0000000f;
    object-fit: contain;
  }
`;
